// Qué entra en la fila de abajo de la caja del chat cuando "Agregar" va con rótulo sólo
// si entra — ADR-2026-09-25-agregar-con-rotulo-en-el-panel-y-con-el-lienzo.
//
// En el panel lateral (420 px) y con el lienzo abierto (la columna mide 460–580) la fila
// es más angosta que en la pantalla del Agente. Lo que se cede, en orden: primero la
// palabra de las pastillas ("Inteligencia Baja" pasa a "Baja", la misma forma que en el
// teléfono) y recién después el rótulo del "+". Nunca se desborda: el mic y el enviar
// tienen su lugar fijo.
//
// Los anchos salen de la fila real (px de CSS, con Plus Jakarta a 13–13,5 px), con el
// nivel MÁS ANCHO ("Media"), no el de la captura ("Baja"):
//   "+ Agregar" ≈ 102 · "Inteligencia Media" ≈ 185 (compacta, "Media", ≈ 104) ·
//   engranaje 36 · mic + enviar 80 · huecos de 6–8.
// Entra todo con ≈ 425 y compacta con ≈ 344; los umbrales dejan 10 px de aire para
// diferencias de fuente (ADR-2026-09-25-los-umbrales-de-la-fila-con-el-nivel-mas-ancho).
// El panel lateral de 420 deja ≈ 370 de fila: entra "Agregar" con las pastillas compactas.
// Puro: sin DOM. La barra le pasa el ancho del contenido de la fila (sin su padding).

/** Con este ancho entra todo: "+ Agregar" y las pastillas con su palabra. */
export const ANCHO_FILA_COMPLETA = 435;
/** Con este ancho entra "+ Agregar" si las pastillas van compactas. */
export const ANCHO_FILA_CON_AGREGAR = 355;

export interface DisposicionDeLaFila {
  /** El "+" lleva la palabra "Agregar". */
  conRotulo: boolean;
  /** Las pastillas van sin su palabra, sólo el ícono y el valor. */
  compactas: boolean;
}

/** `null` = todavía no se midió: se asume que entra todo (el primer pintado ya mide). */
export function disposicionDeLaFila(ancho: number | null): DisposicionDeLaFila {
  if (ancho === null || ancho >= ANCHO_FILA_COMPLETA) return { conRotulo: true, compactas: false };
  if (ancho >= ANCHO_FILA_CON_AGREGAR) return { conRotulo: true, compactas: true };
  return { conRotulo: false, compactas: true };
}
